import './MembershipsEmptyState.css';

import { UserPlus } from 'lucide-react';

type Props = {
  onIssueMembership: () => void;
};

const NoMembersEmptyState = ({ onIssueMembership }: Props) => (
  <section className="memberships-empty" data-testid="no-members-empty-state">
    <span className="memberships-empty__icon" aria-hidden="true">
      <UserPlus size={26} />
    </span>
    <h2 className="memberships-empty__title">No members yet</h2>
    <p className="memberships-empty__body">
      Your tiers are ready. Issue your first membership by phone — if the
      customer doesn&apos;t exist yet, we&apos;ll create the record on the fly.
    </p>
    <button type="button" className="memberships-empty__cta" onClick={onIssueMembership}>
      + Issue your first membership
    </button>
  </section>
);

export default NoMembersEmptyState;
